import React, { useState } from 'react';
import { MessageCircle, X, Phone, Mail, Clock } from 'lucide-react';
import { whatsappNumber } from '../mock';

const ChatFAB = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleWhatsApp = () => {
    const message = encodeURIComponent("Hi! I need help planning my international family trip.");
    window.open(`https://wa.me/${whatsappNumber.replace('+', '')}?text=${message}`, '_blank');
    setIsOpen(false);
  };

  return (
    <>
      {/* FAB Button */}
      <button 
        className="chat-fab"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Chat with us"
      >
        {isOpen ? <X size={28} /> : <MessageCircle size={28} />}
      </button>

      {/* Popup Overlay */}
      {isOpen && (
        <div className="chat-popup">
          <div className="chat-popup-header">
            <div className="chat-popup-info">
              <h3>TravelFamily Support</h3>
              <p className="chat-status">
                <span className="status-dot"></span>
                Online - We reply instantly
              </p>
            </div>
          </div>

          <div className="chat-popup-content">
            <p className="chat-greeting">
              👋 Hi there! How can we help you plan your perfect family vacation today?
            </p>

            <div className="chat-quick-options">
              <button className="quick-option" onClick={handleWhatsApp}>
                <MessageCircle size={18} />
                Chat on WhatsApp
              </button>
              <a href="tel:+919876543210" className="quick-option">
                <Phone size={18} />
                Call Us Now
              </a>
              <a href="mailto:info@travelfamily.com" className="quick-option">
                <Mail size={18} />
                Email Us
              </a>
            </div>

            <div className="chat-hours">
              <Clock size={16} />
              <span>Available 24/7</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatFAB;
